import { useState } from 'react'

export interface GameOption {
  id: string
  title: string
  provider?: string
  background_image?: string
  release_date?: string
}

interface GameDisambiguationReturn {
  isOpen: boolean
  games: GameOption[]
  showDisambiguation: (gameOptions: GameOption[]) => Promise<GameOption | null>
  onSelectGame: (game: GameOption) => void
  onCancel: () => void  
}

export const useGameDisambiguation = () : GameDisambiguationReturn => {
  const [isOpen, setIsOpen] = useState(false)
  const [games, setGames] = useState<GameOption[]>([])
  const [resolveFunction, setResolveFunction] = useState<
    ((game: GameOption | null) => void) | null
  >(null)

  const showDisambiguation = (gameOptions: GameOption[]): Promise<GameOption | null> => {
    setGames(gameOptions)
    setIsOpen(true)
    
    return new Promise((resolve) => {
      setResolveFunction(() => (selectedGame: GameOption | null) => {
        setIsOpen(false)
        setGames([])
        setResolveFunction(null)
        resolve(selectedGame)
      })
    })
  }

  const handleSelectGame = (game: GameOption) => {
    if (resolveFunction) {
      resolveFunction(game)
    }
  }

  const handleCancel = () => {
    if (resolveFunction) {
      resolveFunction(null)
    }
  }

  return {
    isOpen,
    games,
    showDisambiguation,
    onSelectGame: handleSelectGame,
    onCancel: handleCancel,
  }
}

